module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-2000.560c32ca.svg";